// @flow
import React from "react";
import PropTypes from 'prop-types';
import {reisy, use} from "reisy";
import {injectIntl, defineMessages} from 'react-intl';
import type Player from "../player/player.js";

const messages = defineMessages({
	placeholder: {
		id: "searchbutton.placeholder",
		defaultMessage: "Search...",
	},
});

export const styles = reisy`
@namespace Search;

Input {
	width: 100%;
	color: black;
	background: rgba(255, 255, 255, 0.5);
	border: 1px solid rgba(100, 100, 100, 0.15);
	padding: 6px;
	border-radius: 3px;
	font-family: $Fonts.aside;
	font-size: 1em;

	&:focus {
		border-color: #4f98ec;
		outline: none;
		background: rgba(245, 245, 245, 0.9);
	}
}
`;

class SearchButton extends React.Component {
	static contextTypes = {
		player: PropTypes.object,
	};

	context: {player: Player};
	props: {intl: any};

	elem: HTMLFormElement;

	setElem = (elem: HTMLFormElement) => (this.elem = elem);

	handleSubmit = (ev: Event) => {
		ev.preventDefault();
		const input: HTMLInputElement = (this.elem.elements.namedItem("search"): any);
		const term = input.value.trim();
		if (!term) { return; }

		this.context.player.performSearch(term);
	}

	componentDidMount() {
		if (!IS_BROWSER) { return; }
		this.elem.addEventListener("submit", this.handleSubmit, false);
	}
	componentWillUnmount() {
		this.elem.removeEventListener("submit", this.handleSubmit);
	}

	render() {
		const {formatMessage} = this.props.intl;
		return (
			<form ref={this.setElem}>
				<input {...use(styles.Input)} name="search" type="search" placeholder={formatMessage(messages.placeholder)} />
			</form>
		);
	}
}

export default injectIntl(SearchButton);



// WEBPACK FOOTER //
// ./lib/components/searchbutton.js